import { Card, Button, CardGroup } from "react-bootstrap";
import { Link } from "react-router-dom";

const ListingCard = ({ listing, buttonText }) => {
  return (
    <Card
      key={listing.id}
      style={{
        borderRadius: "15px",
        margin: "10px",
        border: "0px",
        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
        padding: "10px",
        height: "100%",
      }}
    >
      <Card.Body>
        <Card.Img
          variant="top"
          src={listing.logo_url}
          style={{ width: "60%" }}
        />

        {/* <Card.Title>{listing.name}</Card.Title> */}
        <Card.Text>{listing.description}</Card.Text>
      </Card.Body>

      <Link to={`/listings/${listing.id}`}>
        <Button className="btn-hover color-1">
          {buttonText || "View Details"}{" "}
        </Button>
      </Link>
    </Card>
  );
};

const ListingCardGroup = ({ listings, buttonText }) => {
  return (
    <CardGroup className="d-flex flex-wrap w-100">
      {listings.map((listing) => (
        <div className="col-lg-3 col-md-6 mb-4">
          <ListingCard
            key={listing.id}
            listing={listing}
            buttonText={buttonText}
          />
        </div>
      ))}
    </CardGroup>
  );
};
export default ListingCardGroup;
